<template>
    <div class="row align-items-center no-gutters">
        <div class="col-md-6">
            <div class="d-flex align-items-center">
                <img :src="imageUrl" width="60px" class="rounded">

                <p class="mb-0 flex-grow-1 ml-3">
                    <span v-if="showQuantity" class="text-primary font-weight-bold quantity">
                        {{ upsellPackage.quantity }}x
                    </span>
                    {{ upsellPackage.package_name }}
                    <span v-if="replacedBasketItem">
                        <br><span class="text-muted small">{{ $t("upselling.replaces") }}: {{ replacedBasketItem.name }}</span>
                    </span>
                </p>
            </div>
        </div>
        <div class="col-6 col-md-3 d-flex justify-content-md-end">
            <div class="d-flex align-items-center">
                <p v-if="isOnSale" class="text-danger mb-0 price">
                    {{ basket.price.currencySymbol ? basket.price.currencySymbol : store.currencySymbol }}
                    {{ price.toFixed(2) }}
                </p>
                <p class="text-primary font-weight-bold offer-price mb-0 ml-2">
                    {{ basket.price.currencySymbol ? basket.price.currencySymbol : store.currencySymbol }}
                    {{ offerPrice.toFixed(2) }}
                </p>
            </div>
        </div>
        <div class="col-6 col-md-3 text-right">
            <template v-if="added">
                <button v-if="showAdded" class="btn btn-soft-primary btn-sm" disabled>
                    <i class="fa fa-check"></i>
                    {{ $t("buttons.added") }}
                </button>
                <button v-else class="btn btn-soft-primary btn-sm" @click="removeUpsellPackage" :disabled="loading">
                    <i class="fa fa-minus-circle"></i>
                    {{ $t("buttons.remove") }}
                </button>
            </template>
            <button v-else class="btn btn-soft-primary btn-sm" @click="addUpsellPackage" :disabled="loading">
                <i class="fa fa-plus-circle"></i>
                {{ $t("buttons.add") }}
            </button>
        </div>
        <Options
            :show-modal="showModal"
            :id="upsellPackage.uuid"
            :title="upsellPackage.package_name"
            :package="upsellPackage.package_id"
            :options="modalOptions"
            @validated="processValidatedOptions"
            @closed="showModal = false"/>
    </div>
</template>

<script>

import {mapState} from "vuex";
import Options from "../Options";
import {cloneDeep} from "lodash";

export default {
    name: "UpsellPackage",
    data() {
        return {
            added: false,
            loading: false,
            showAdded: false,
            showModal: false,
            validatedOptions: null,
            modalOptions: cloneDeep(this.upsellPackage.options).map(option => {
                // Set default value to null
                option.value = null;
                return option;
            })
        }
    },
    props: {
        upsellPackage: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            store: state => state.app.store,
            basket: state => state.basket
        }),
        isOnSale() {
            return this.price > this.offerPrice;
        },
        imageUrl() {
            if (this.upsellPackage.image_url === null) {
                return "/img/package-default.png"
            }

            return this.upsellPackage.image_url;
        },
        showQuantity() {
            return this.upsellPackage.type === 'quantity';
        },
        offerPrice() {
            if (this.upsellPackage.type === 'quantity') {
                return this.upsellPackage.offer_price * this.upsellPackage.quantity
            }

            return this.upsellPackage.offer_price;
        },
        price() {
            if (this.upsellPackage.type === 'quantity') {
                return this.upsellPackage.price * this.upsellPackage.quantity
            }

            return this.upsellPackage.price;
        },
        replacedBasketItem() {
            if (this.upsellPackage.type !== 'alternative') {
                return null;
            }

            let replacedBasketItem = this.basket.items.find((item) => {
                return item.package === this.upsellPackage.replacementPackageId;
            })

            return replacedBasketItem ? replacedBasketItem : null;
        },
        hasOptions() {
            return this.upsellPackage.options.length > 0;
        }
    },
    methods: {
        addUpsellPackage() {
            if (this.hasOptions && this.validatedOptions === null) {
                this.showModal = true;
                return;
            }

            this.loading = true;

            let args = {'uuid': this.upsellPackage.uuid, 'options': this.validatedOptions};

            this.$store.dispatch('addUpsellPackage', args)
                .then(() => {
                    this.loading = false;
                    this.showAdded = true;
                    this.added = true;

                    setTimeout(() => this.showAdded = false, 1200);
                })
                .catch((error) => {
                    this.loading = false;
                    this.$swal({type: 'error', text: error.response.data.message});
                });
        },
        removeUpsellPackage() {
            this.loading = true;

            const basketItem = this.basket.items.find((item) => {
                return item.package === this.upsellPackage.package_id;
            });

            if (!basketItem) {
                this.$emit('removed');
                return;
            }

            this.$store.dispatch('removeBasketItem', basketItem.id)
                .then(() => {
                    this.loading = false;
                    this.$emit('removed');
                })
                .catch((error) => {
                    this.loading = false;
                    this.$swal({type: 'error', text: error.response.data.message});
                });
        },
        processValidatedOptions(options) {
            this.validatedOptions = options;
            this.showModal = false;

            this.addUpsellPackage();
        }
    },
    components: {
        Options
    }
}
</script>

<style lang="scss" scoped>
.price {
    text-decoration: line-through;
    font-weight: 400;
    font-size: 14px;
    padding-top: 2px;
}

.offer-price {
    font-size: 17px;
}

.quantity {
    padding-top: 2px;
    font-size: 17px;
}

</style>
